import * as options from "./options";
import * as contentTags from "./contentTags";
import * as tagsCounter from "./tagsCounter";
import * as initialFetchAll from "./initialFetchAll";
import * as page from "./page";
import * as subscriber from "./subscriber";
import * as ui from "./ui";
import * as events from "./events";
import * as clubs from "./clubs";
import * as user from "./user";
import * as cart from "./cart";

const actions = {
    ...options,
    ...initialFetchAll,
    ...page,
    ...subscriber,
    ...ui,
    ...tagsCounter,
    ...contentTags,
    ...events,
    ...clubs,
    ...user,
    ...cart,
};

export default actions;
